<!--  -->
<template>
    <div class=''>
        <Modal :title="title" width="660px" @on-ok="confirm" @on-cancel="cancel" v-model="showAdd">
            <div class="add-wrapper">
                <!-- 搜索 展示 -->
                <div class="add-search">
                    <slot></slot>
                    <!-- 搜索输入框 -->
                    <div class="tr box">
                        <div class="tr_title" :style="{width:labelWidth}">{{trTitle}}</div>
                        <Input
                            class="add-input"
                            placeholder="请输入.."
                            size="large"
                            type="text"
                            search
                            enter-button="搜索"
                            v-model="searchValue"
                            @on-search="onAddSearch"
                        />
                    </div>
                    <div class="tr box">
                        <div class="tr_title">类型</div>
                        <RadioGroup v-model="type" @on-change="radioChange">
                            <Radio v-for="item in typelist" :label="item" :key="item">
                                <span>{{item}}</span>
                            </Radio>
                        </RadioGroup>
                    </div>
                    <div class="loading" v-if="isLoading">
                        <Spin fix>
                            <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
                            <div>加载中..</div>
                        </Spin>
                    </div>
                    <!-- 没有搜索结果提示 -->
                    <div class="nolist" v-if="!isLoading && noSearchResult">未搜索到信息，请确认系统存在该用户或者企业。</div>
                    <!-- 搜索结果列表 -->
                    <div class="search-list" v-if="!isLoading && searchResList.length">
                        <!-- 结果类目 -->
                        <div
                            class="search-item"
                            :class="{select:item.select}"
                            @click="onSelect(index)"
                            v-for="(item,index) in searchResList"
                            :key="item.id"
                        >
                            <!-- 头像 -->
                            <img
                                class="search-avatar"
                                v-lazy="item.headPicUrl || require('@/assets/images/default.png')"
                            >
                            <!-- 名字 -->
                            <span class="search-name">{{item.realName}}</span>
                            <span class="user-name">{{item.userName}}</span>
                        </div>
                    </div>
                </div><!--add-search-->
                <!-- 勾选人员列表 -->
                <div class="select-list">
                    <div
                        class="select-item"
                        v-for="(selectItem,selectIndex) in searchSelectList"
                        :key="selectItem.id"
                    >
                        {{selectItem.userName}}
                        <span
                        class="select-del"
                        title="移除"
                        @click="removeSelect(selectItem.id)"
                        ></span>
                    </div>
                </div>
            </div><!--wrapper-->
        </Modal>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    props: {
        title:{
            type:String,
            default:'参会人'
        },
        peopleList:{
            type:Array,
            default() {
                return [];
            },
        },
        labelWidth:{
            type:String,
            default:'45px'
        },
        api:{
            type:String,
            default(){
                return this.urlobj.getPerson
            },
        },
      trTitle:{
          type:String,
        default:'参会人'
      }
    },
    data() {
    //这里存放数据
        return {
            isLoading:false,//加载中
            showAdd:true,
            type:'企业',
            typelist:['企业','社工','居民'],
            searchValue:"",
            noSearchResult:false,
            searchResList:[],//搜索结果列表
            searchSelectList:[],//选中列表
            searchSelectId:[],//选中Id
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        getPeople(type,searchValue) {
            this.isLoading = true
            this.searchResList = []
            var url = this.api;
            var data = {
                pageNum: 0,
                pageSize: 0,
                communityId:this.$store.state.streetorcommunityid,
                queryType: type,
                searchValue:searchValue,
            };
            this.$get(url, data).then(res => {
                if(type=='company'){
                    this.searchResList =  res.rows.map(item=>{
                        return {
                            type:'company',
                            id:item.id,
                            select:this.searchSelectId.includes(item.id), // 是否被选中 id是否出现在被选中的列表里,
                            userName:item.name,
                            name:item.name,
                            userList:item.userList,
                            headPicUrl:item.headPicUrl,
                        }
                    })
                }else{
                    this.searchResList = res.rows.map(item=>{
                        console.log(this.searchSelectId)
                        console.log()
                        return {
                            type:type,
                            id:item.uId,
                            unionId:item.unionId,
                            select:this.searchSelectId.includes(item.uId), // 是否被选中 id是否出现在被选中的列表里,
                            userName:item.userName,
                            realName:item.realName?item.realName:'暂无姓名',
                            name:(item.realName?item.realName:'暂无姓名')+'('+item.userName+')',
                            headPicUrl:item.headPicUrl,
                        }
                    })
                }
                this.isLoading = false
            }).catch(e => {
                this.isLoading = false
                console.log(e)
            });
        },
        confirm(){
            let data = this.searchSelectList
            console.log(data)
            this.$emit("modalSelect",data)
        },
        cancel(){
            this.$emit("modalCancel")
        },
        onAddSearch(){
            //搜索
            let type = this.getType()
            let searchValue = this.searchValue
            this.getPeople(type,searchValue)
        },
        getType(){
            let returntype = 'company'
            switch(this.type){
                case '企业':
                    returntype="company";
                    break;
                case '社工':
                    returntype="worker";
                    break;
                case '居民':
                    returntype="resident";
                    break;

            }
            return returntype
        },
        radioChange(){
            let type = this.getType()
            this.getPeople(type,"")
        },
        onSelect(index){

            this.searchResList[index].select = !this.searchResList[index].select
            let item = this.searchResList[index];
            if(item.select){
                //如果没选中，则选中

                this.searchSelectList.push(item)
                this.searchSelectId.push(item.id)
            }else{
                //取消选中
                //右侧
                let selectIndex = this.searchSelectId.indexOf(item.id);
                this.searchSelectId.splice(selectIndex, 1)
                this.searchSelectList.splice(selectIndex, 1)
                //左侧去掉选中标识
                this.searchResList.forEach(item => {
                    if (!this.searchSelectId.includes(item.id)) item.select = false;
                });
            }


        },
        removeSelect(id){

            //去掉右侧选中列表
            let selectIndex = this.searchSelectId.indexOf(id);
            this.searchSelectId.splice(selectIndex, 1)
            this.searchSelectList.splice(selectIndex, 1)

            //去掉左侧选中标识
            this.searchResList.forEach(item => {
                if (!this.searchSelectId.includes(item.id)) item.select = false;
            });

        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.searchSelectList = [...this.peopleList];
        this.searchSelectId =  this.searchSelectList.map(item=>item.id)
        this.getPeople("company");
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
/* 对话框 （新增签到人） */
@mainColor: #ff7b44;
.add-wrapper {
  height: 366px;
  display: flex;
  align-items: center;
}
.add-search {
  width: 400px;
  height: 100%;
  border-right: 1px solid #ddd;
  display: flex;
  flex-direction: column;
  padding-right: 10px;
}
.add-input {
  margin-bottom: 10px;
}
/* 搜索结果列表 */
.noIEBar {
  // ie 10 11 12
  -ms-scroll-chaining: chained;
  -ms-overflow-style: none;
  -ms-content-zooming: zoom;
  -ms-scroll-rails: none;
  -ms-content-zoom-limit-min: 100%;
  -ms-content-zoom-limit-max: 500%;
  -ms-scroll-snap-type: proximity;
  -ms-scroll-snap-points-x: snapList(100%, 200%, 300%, 400%, 500%);
  -ms-overflow-style: none;
}
.select-all {
  align-self: flex-end;
  padding: 6px 10px;
  font-size: 12px;
  line-height: 1;
  color: #fff;
  border-radius: 4px;
  background-color: #ff5b33;
  margin: 10px 0;
  cursor: pointer;
  user-select: none;
  &:hover {
    background-color: #ff7c5c;
  }
}
.nolist {
  flex: 1;
  font-size: 12px;
  color: #d22b2b;
  display: flex;
  align-items: center;
  justify-content: center;
}
.search-list {
  flex: 1;
  padding-top: 10px;
  padding-right: 10px;
  overflow: hidden;
  overflow-y: scroll;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 15px;
  align-content: start;
  // chrome
  &::-webkit-scrollbar {
    display: none;
  }
  .noIEBar;
}
.search-item {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 150px;
  border: 1px solid #eee;
  border-radius: 8px;
  &:hover {
    box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.2);
  }
}
/* 已报名 */
.search-item-apply {
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 0;
  border-top: 22px solid #47ba53;
  border-right: 22px solid transparent;
  border-left: 22px solid #47ba53;
  border-bottom: 22px solid transparent;
  border-top-left-radius: 8px;
}
.apply-state {
  position: absolute;
  top: -13px;
  left: -24px;
  font-size: 12px;
  color: #fff;
  line-height: 1.1;
  white-space: nowrap;
  transform: rotate(-45deg) scale(0.8);
}
.select {
  border-color: @mainColor;
}
.select:after {
  content: "";
  position: absolute;
  right: -10px;
  top: -10px;
  z-index: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: @mainColor;
}
.select:before {
  content: "";
  position: absolute;
  right: -3px;
  top: -6px;
  z-index: 1;
  width: 6px;
  height: 10px;
  border-right: 1px solid #fff;
  border-bottom: 1px solid #fff;
  transform: rotateZ(45deg);
}
.search-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-top: 30px;
  margin-bottom: 20px;
}
.search-name {
  font-size: 14px;
  color: #444;
}
.user-name{
    font-size: 10px;
    color:#999
}
/* 选中人员列表 */
.select-list {
  max-height: 100%;
  flex: 1;
  align-self: flex-start;

  display: flex;
  flex-wrap: wrap;
  align-items: center;
  align-content: flex-start;
  overflow: hidden;
  overflow-y: scroll;

  padding-left: 20px;
  &::-webkit-scrollbar {
    display: none;
  }
  .noIEBar;
}
.select-item {
  display: flex;
  align-items: center;

  white-space: nowrap;
  margin-right: 5px;
  margin-bottom: 10px;
  padding: 6px 10px;

  line-height: 1.2;
  font-size: 14px;
  color: #999;
  border: 1px dashed #999;
  border-radius: 4px;
  &:hover {
    color: @mainColor;
    border-color: @mainColor;
    .select-del {
      background-color: @mainColor;
    }
  }
}
/* 删除按钮伪类 */
.select-del-icon(@rotate:0) {
  content: "";
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 7px;
  height: 1px;
  background-color: #fff;
  transform: translate(-50%, -50%) rotateZ(@rotate);
}
/* 删除按钮 */
.select-del {
  position: relative;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  margin-left: 5px;
  color: #fff;
  background-color: #999;
  cursor: pointer;
  &::before {
    .select-del-icon(45deg);
  }
  &::after {
    .select-del-icon(-45deg);
  }
}
.tr{
    line-height: 36px;
    .tr_title{
        margin-right: 20px;
        width: 45px;
    }
}

/*加载中*/
.loading{
    position: relative;
    height:100%
}
.demo-spin-icon-load{
    animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
}
</style>
